/* MAISON MERCIER — défilement infini corrigé (src/menu/86-le-defilement-infini.mjs, 2026-10-01).
   Mesuré avant : /collections/femme montrait 50 produits sur 159. Le lien observé fait 0x0 px et ne
   déclenchait que s'il traversait les 70 % du haut de l'écran : un défilement rapide (molette, Fin,
   barre) passait par-dessus et la suite ne se chargeait jamais. Et `window.scrollLoad = true` juste
   avant le test rendait la garde inopérante.
   Correctif : on charge dès que le lien est à moins de 800 px du bas de l'écran OU déjà dépassé
   (contrôle au défilement + observateur élargi), avec une garde par instance, et on enchaîne tant
   qu'on reste près du bas. */
if (!customElements.get("pagination-load-more")) {
    class PaginationLoadMore extends HTMLElement {
        constructor() {
            super();

            this.loadMoreBtn = this.querySelector(".pagination-load-more");
            this.paginationType = this.dataset.paginationType;
            this.enCours = false;
            this.verifier = this.verifier.bind(this);
            if (!this.loadMoreBtn) return;
        }

        connectedCallback() {
            if (!this.loadMoreBtn) return;
            if (this.paginationType == "infinity_scroll") {
                this.infinityScroll();
            } else {
                this.loadMoreBtn.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.loadNextPage();
                });
            }
        }

        infinityScroll() {
            window.infiniteScrollObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) this.loadNextPage();
                    });
                },
                { root: null, rootMargin: "0px 0px 800px 0px", threshold: 0 }
            );
            window.infiniteScrollObserver.observe(this.loadMoreBtn);

            window.addEventListener("scroll", this.verifier, { passive: true });
            window.addEventListener("resize", this.verifier, { passive: true });
            this.verifier();
        }

        /* Le lien est-il proche du bas de l'écran, ou déjà dépassé ? */
        verifier() {
            if (this.enCours || !this.loadMoreBtn || !this.loadMoreBtn.isConnected) return;
            if (this.loadMoreBtn.getBoundingClientRect().top < window.innerHeight + 800) this.loadNextPage();
        }

        arreter() {
            window.removeEventListener("scroll", this.verifier);
            window.removeEventListener("resize", this.verifier);
            window.infiniteScrollObserver?.unobserve(this.loadMoreBtn);
        }

        loadNextPage() {
            if (this.enCours || !this.loadMoreBtn || !this.loadMoreBtn.isConnected) return;
            this.enCours = true;

            let loadMoreBtn = this.loadMoreBtn;
            let url = this.getPageUrl(),
                sources = ["[data-product-id]", "[data-collection-id]", "[data-article-id]"];

            this.showLoader();

            fetch(url)
                .then((response) => response.text())
                .then((text) => {
                    this.hideLoader();

                    let itemsChildren = null,
                        dataHtml = new DOMParser().parseFromString(text, "text/html");

                    sources.forEach((source) => {
                        itemsChildren = dataHtml.querySelectorAll(`[data-list-items] ${source}`);

                        if (itemsChildren.length === 0) return;

                        // filter items availability
                        if (url.includes("availability=1"))
                            itemsChildren = [...itemsChildren].filter((item) => !item.classList.contains("sold-out"));
                        else if (url.includes("availability=0"))
                            itemsChildren = [...itemsChildren].filter((item) => item.classList.contains("sold-out"));

                        // add new items to the end of the list
                        this.appendItems(itemsChildren);
                    });

                    let currentPageNumber = JSON.parse(new URL(loadMoreBtn.href)?.searchParams?.get("page")),
                        nextPage = dataHtml.querySelector(".pagination-load-more")?.href,
                        nextPageNumber = nextPage && JSON.parse(new URL(nextPage)?.searchParams?.get("page"));

                    if (nextPage && nextPageNumber !== null && nextPageNumber !== currentPageNumber) {
                        loadMoreBtn.href = nextPage;
                        history.pushState(null, "", nextPage);
                        this.enCours = false;
                        /* encore près du bas ? on enchaîne, après la mise en page */
                        requestAnimationFrame(() => this.verifier());
                    } else {
                        this.arreter();
                        loadMoreBtn.remove();
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.hideLoader();
                    this.enCours = false;
                });
        }

        getPageUrl() {
            let url = this.loadMoreBtn.href;
            const filtersForm = document.querySelector("collection-filters-form");

            if (filtersForm) {
                const formData = new FormData(filtersForm.form);
                const separator = url.includes("?") ? "&" : "?";
                const searchParams = new URLSearchParams(formData).toString();
                if (searchParams) url += separator + searchParams;
            }

            return url;
        }

        appendItems(items) {
            const listItems = document.querySelector("[data-list-items]");

            items.forEach((item) => {
                if (item.nodeName === "LI" || item.nodeName === "ARTICLE") listItems.appendChild(item);
            });

            this.updateRevealAnimation();
            this.reinitPreloadImages();
        }

        async updateRevealAnimation() {
            const listItems = document.querySelector("[data-list-items]");
            const revealList = listItems && listItems.closest(".reveal-slide-in");

            if (!revealList) return;

            const revealListArr = [listItems];
            if (typeof onReveal === "function") await onReveal(revealListArr);
            if (typeof updateItemZIndex === "function") await updateItemZIndex(revealListArr);
        }

        async reinitPreloadImages() {
            const listItems = document.querySelector("[data-list-items]");
            const blurImages = listItems?.querySelectorAll(".media--blur-image");

            blurImages && blurImages.length > 0 && typeof _preloadImg === "function" && (await _preloadImg(blurImages));
        }

        showLoader() {
            let btn = this.loadMoreBtn;
            if (!btn) return;
            if (!btn.querySelector(".loading-overlay") && typeof createFromTemplate === "function")
                btn.prepend(createFromTemplate("template-loading-overlay"));

            btn.classList.add("loading");
            if (btn.children[0]?.classList.contains("hidden")) btn.children[0].classList.remove("hidden");
        }

        hideLoader() {
            let btn = this.loadMoreBtn;
            if (!btn) return;
            btn.children[0]?.classList.add("hidden");
            btn.classList.remove("loading");
        }

        disconnectedCallback() {
            this.arreter();
        }
    }

    customElements.define("pagination-load-more", PaginationLoadMore);
}
